export interface PagedResult<T> {
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    items: T[];
}

export interface Step {
    id: number,
    name: string,
    notifications: NotificationTypeSettings[],
    departments: Department[]
}

export interface NotificationTypeSettings {
    type: NotificationType,
    on: boolean
}

export interface UserNotificationSettings {
    userId: number,
    channels: NotificationChannel[],
    autoCreateSubscriptionEnabled: boolean
}

export interface Department {
    id: number,
    name: string
}

export enum NotificationChannel {
    None = 0,
    App = 1,
    Email = 2,
    Teams = 3,
}

export enum NotificationType {
    None = 0,
    Sucess = 1,
    Critical = 2
}

export interface UpsertUserNotificationSettings {
    userId: number;
    autoCreateSubscriptionEnabled: boolean;
    channels: NotificationChannel[];
    stepNotifications: UpsertUserStepNotificationSettings[];
}

export interface UpsertUserStepNotificationSettings {
    stepId: number;
    notifications: NotificationTypeSettings[];
}